module.exports = __webpack_public_path__ + "static/media/logo.9f254cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 95
// module chunks = 0